import React from "react";
import leftArrow from "../../../assets/images/common/left-arrow.svg";
import rightArrow from "../../../assets/images/common/right-arrow.svg";
import {PaginationProps} from "./Pagination.props";

export default function Pagination(props: PaginationProps) {
    const PAGE_SIZE: number = 5;
    const onPageNumberClick = (page: number) => {
        props.onChange(page);
    }

    const getPageList = (): number[] => {
        let pageList: number[] = [];

        if (props.currentPage !== undefined) {
            const currentPage = props.currentPage;
            let pageGroup: number = Math.ceil((currentPage + 1) / PAGE_SIZE);
            let lastPageNum: number = pageGroup * PAGE_SIZE;
            let firstPageNum: number = lastPageNum - PAGE_SIZE;

            for (let i: number = 0; i < PAGE_SIZE; i++) {
                pageList[i] = firstPageNum + i;
            }

            for (let i: number = 0; i < pageList.length; i++) {
                if (pageList[i] + 1 > props.totalPage) {
                    pageList.splice(i);
                }
            }
        }

        return pageList;
    }

    const onPrePageClick = () => {
        if (props.currentPage > 0) {
            props.onChange(props.currentPage - 1);
        }
    }

    const onNextPageClick = () => {
        if (props.currentPage < props.totalPage - 1) {
            props.onChange(props.currentPage + 1);
        }
    }

    const onFirstPageClick = () => {
        props.onChange(0);
    }

    const onLastPageClick = () => {
        props.onChange(props.totalPage - 1);
    }

    return (
        <section className="paging-section">
            <button className="first-page" onClick={onFirstPageClick}>
                <img src={leftArrow} alt="firstArrow"/>
            </button>
            <button className="pre-page" onClick={onPrePageClick}>
                <img src={leftArrow} alt="beforeArrow"/>
            </button>
            <div className="page">
                {
                    getPageList().map((index, i) => {
                        return (
                            <div
                                key={i}
                                className={`number ${props.currentPage === index ? "now-number" : ""}`}
                                onClick={() => onPageNumberClick(index)}
                                data-testid="pageNumber"
                            >
                                {index + 1}
                            </div>
                        )
                    })
                }
            </div>
            <button className="next-page" onClick={onNextPageClick}>
                <img src={rightArrow} alt="nextArrow"/>
            </button>
            <button className="last-page" onClick={onLastPageClick}>
                <img src={rightArrow} alt="lastArrow"/>
            </button>
        </section>
    )
}